import styled from 'styled-components'
import { CssVars } from '@bp-digital/theme'

export const Message = styled.div`
  display: flex;
  align-items: center;
  color: ${CssVars.palette.accent.orangeDark};
`
